import type { FaireProductEntity } from "../../entity_types/product";

export const p_4r7evs2pha: FaireProductEntity = {
  token: "p_4r7evs2pha",
  type: "product",
  name: "Cold Brew Concentrate",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl: "https://cdn.faire.com/fastly/471f9ed6c76281b5e7c688b9f7db3e89773bfcb0e0a74411f005016ecdc96bc2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/abbdec8c6ab2071187c6361c3e3cb0a8cd02fc64d67d9c46af4b465ac0edeefe.jpeg",
    "https://cdn.faire.com/fastly/4eab38b4456d7458a2ff75938838be6d45ae793cc6e28390fbe01f0876a50e9e.jpeg",
    "https://cdn.faire.com/fastly/6d5996a2aba5723c3abe3229da1bd64268a27399cf458b1139cc6db79e035390.png"
  ],
  priceDollars: 56.1,
  description: "Cold brew, without the hassle.\nA shelf-stable liquid coffee concentrate that can be used to easily make cold brew simply by diluting with water. At a TDS of 14%, the concentrate can also be used as an espresso substitute — whether you’re making iced lattes or espresso martinis!\nSize\nThe concentrate comes in a 32oz bottle, which yields 2.5 gallons of cold brew. The bottles come in a case of 4, so each case equates to 10 gallons of cold brew.\nShelf stable\nThe product is shelf-stable at room temperature for 6 months. Once opened and diluted, the resulting beverage is good for 1 month, if refrigerated.\nThe coffee\nFor this first run, we used our Regenerative Organic Certified coffee grown by the ASPRASAR Co-op of Tolima Department in Colombia — a group we’ve worked with since 2017. The product is smooth, sweet and balanced, with no bitterness.\n\n\nMade for:\n\nCocktails\nIced lattes\nAffogatos\nAmericanos",
  tags: [],
  msrpDollars: 112.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:35.137Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
